<template>
    <div v-if="datas">
        <Wp_nav_bar :title="datas.title"></Wp_nav_bar>

        <div>
            <Wp_mini_grow_task_card style="margin-top: 20px">
                <div slot="title" style="text-align: center">
                    如何参与活动?
                </div>
                <div slot="content" v-html="datas.desc.replace(new RegExp('\\n','g'), '<br/>')">
                </div>
            </Wp_mini_grow_task_card>
        </div>

        <div>
            <Wp_mini_grow_task_card style="margin-top: 20px">
                <div slot="title" style="text-align: center">
                    活动文案
                </div>
                <div slot="content" v-html="content">

                </div>
            </Wp_mini_grow_task_card>

            <div style="padding: 20px">
                <Wp_image ref="share_img" v-if="datas.share_img" :url="datas.share_img"></Wp_image>
            </div>

            <van-sticky class="bottom_button" :style="{bottom: bottom_px}">
                <van-row>
                    <van-col span="12" style="padding-right: 1px">
                        <van-button size="large"
                                    type="primary"
                                    v-clipboard:copy="content.replace(new RegExp('<br/>','g'), '\n')"
                                    v-clipboard:success="onCopySuccess"
                                    v-clipboard:error="onError"
                        >复制文案
                        </van-button>
                    </van-col>
                    <van-col span="12" style="padding-left: 1px">
                        <van-button size="large" type="info" @click="clickToShare(datas.share_img)">分享图片</van-button>
                    </van-col>
                    <van-image-preview
                            v-model="showPreview"
                            :images="preview_images"
                    >
                        <!--                        <div slot="">第{{ index }}页</div>-->
                    </van-image-preview>
                </van-row>
            </van-sticky>
        </div>

        <!--        <van-popup v-model="showLoading">-->

        <!--            <van-loading type="spinner" color="#1989fa" vertical-->
        <!--                         style="padding: 30px;">-->
        <!--                <div slot="default" style="text-align: center">加载中...</div>-->
        <!--            </van-loading>-->

        <!--        </van-popup>-->
    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_mini_grow_task_card from "../custom/Wp_mini_grow_task_card";
    import Wp_image from "../custom/Wp_image";
    export default {
        name: "Wp_home_module_page",
        components: {Wp_image, Wp_mini_grow_task_card, Wp_nav_bar},

        data(){
            return{
                datas: null,
                content: "",
                showLoading: true,

                showPreview: false,
                preview_images: [],

                bottom_px: "50px",
            }
        },

        created() {
            this.initDatas();

            // if(this.$router.query && this.$router.query.pop_data){
            //     let datas = JSON.parse(decodeURIComponent(this.$router.query.pop_data))
            //     this.$log(datas)
            // }
            this.$wx.miniProgram.getEnv(res => {

                if (res.miniprogram) {
                    this.bottom_px = '0px';
                }else{
                    this.bottom_px = '50px';
                }
            });
        },

        watch:{
            // content(newContent){
            //     // this.getcontent(newContent);
            // }
        },

        methods:{
            initDatas(){
                if(this.$common.static_home_module_datas){
                    this.datas = this.$common.static_home_module_datas;

                    // datas示例
                    // {
                    //     "type": 1,
                    //     "img": "https://jd.wapg.cn/images/banner_1.jpg",
                    //     "desc": "1.复制以下文案并微信发送给自己↵2.通过微信访问活动地址购买↵",
                    //     "title": "活动详情",
                    //     "content": "🔥赶快抢【京享红包】最高888元🎁每天抢3次，抢到就是赚到😄↵⏰1月7日红包奖池加倍！👇↵主会场👉https://u.jd.com/gczJdq↵🎉超市会场👉https://u.jd.com/CBnJ6a",
                    //     "share_img": "https://jd.wapg.cn/images/share_pop.jpg",
                    // }

                    this.initContentAndLink(this.datas.content, newContent=>{
                        this.content = this.formatContent(newContent);
                    });
                }
            },


            formatContent(content){
                if(content){
                    return content.replace(new RegExp('\\n','g'), '<br/>');
                }
            },

            initContentAndLink(content, fn) {
                if (content) {
                    let params = {
                        content: content,
                        pid: this.$common.getUsername(),
                        hard: "yes"
                    };

                    this.$getChangeLink(params, response => {
                        this.$log("response = " + response);


                        if (response && response.code === 200) {

                            // this.content = response.content;
                            if(fn){
                                fn(response.content);
                            }

                        } else if (response.code === 0) {
                            this.$dialog.alert({
                                message: '红包链接生成暂无响应'
                            });
                        } else if (response.code >= 500) {
                            if(response.message && response.message.indexOf("pid") !== -1
                                && this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.id){

                                this.$dialog.alert({
                                    message: "该活动仅限超级会员，您可完成超级会员任务，并升级为超级会员"
                                }).then(()=>{
                                    this.$common.switchTabMiniProgramPage("../wp_guide/wp_guide")
                                });
                            }else if(response.temp === 500 && response.message){//temp为pid为空时的自定义
                                this.$dialog.alert({
                                    message: "该活动仅限超级会员，您可完成超级会员任务，并升级为超级会员"
                                }).then(()=>{
                                    // this.$common.switchTabMiniProgramPage("../wp_select/wp_select")
                                    this.$router.back();

                                });
                            }else{
                                this.$dialog.alert({
                                    message: response.message,
                                })
                            }
                        } else if (response.toString().indexOf('Error') != -1) {
                            if (response.toString().indexOf('timeout') != -1) {
                                this.$dialog.alert({
                                    message: '红包链接生成超时，请重试'
                                });
                            } else {
                                this.$dialog.alert({
                                    message: '红包链接生成错误，请重试'
                                });
                            }
                        }

                    })

                    // this.show_paste_sheet_model = false;

                    setTimeout(() => {
                        this.loading_text = "转链操作较为耗时，请耐心等待..."
                    }, 5000);
                }
            },

            clickToShare(img){
                this.preview_images = [img];
                this.showPreview = true;

                // this.$refs.share_img.$el.focus();
            },

            onCopySuccess(){
                this.$toast.success({
                    message:"文案复制成功"
                })
            },

            onError(){
                this.$toast.fail({
                    message:"文案复制失败，请尝试手动复制文案"
                })
            }
        }
    }
</script>

<style scoped>
    .bottom_button{
        padding: 0px 20px; position: fixed; width: 100%;
    }
</style>